import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import RoiSummary from 'containers/Dashboard/ROI/Summary';
import SharedCanvas from 'containers/Dashboard/components/SharedCanvas';
import { useDashboardContext } from 'containers/Dashboard/context/DashboardContext';

function RoiCanvas() {
  const { canvasId } = Route.useParams();
  const { selectedDate, roiData, teepData } = useDashboardContext();

  if (canvasId === 'summary') {
    return (
      <RoiSummary selectedDate={selectedDate} roiData={roiData} teepData={teepData} />
    );
  }
  return <SharedCanvas dashboard="roi" canvasId={canvasId} />;
}

export const Route = createFileRoute('/_authenticated/dashboard/roi/$canvasId')({
  component: RoiCanvas,
});
